<template>
  <div class="reports-add-joint">
    <el-button size="mini" class="add-btn-joint" :disabled="!line" @click="open">Создать стык</el-button>

    <el-dialog
      :title="`Создать новый стык`"
      :visible.sync="isCreateJoint"
    >
      <div v-if="isCreateJoint" class="jobs-create-container">
        <div class="joint">
          <div>
            <div class="s-p">
              <div class="link-block">
                <el-checkbox v-model="createJoinInternal">Доп. стык</el-checkbox>
              </div>
              <el-form-item :label="`Номер стыка`">
                <el-input placeholder="Задайте номер стыка" v-model="joints.start"/>
              </el-form-item>
            </div>
          </div>
          <div class="in-line">
            <el-form-item :label="`Диаметр`">
              <el-input v-model="joints.dia" @input="onJoinInput(joints)"/>
            </el-form-item>
            <el-form-item :label="`Толщина`">
              <el-input v-model="joints.thi" @input="onJoinInput(joints)"/>
            </el-form-item>
            <el-form-item :label="`Дюймы`">
              <el-input v-model="joints.inc"/>
            </el-form-item>
          </div>
          <el-form-item :label="`Марка стали`">
            <el-input v-model="joints.steel_grade"/>
          </el-form-item>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="save">Сохранить
        </el-button>
        <el-button @click="isCreateJoint = true">Отмена</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import JobsCreate from '../../Jobs/Create';
import Create from '../../WorkType/Create';
import _ from 'lodash';
import firebase from 'firebase';
import {v4 as uuidv4} from 'uuid';
import {toFloat} from '../../../../utils/numberUtils';
import {getInches} from "../../../../firestore/inch";

export default {
  name: 'AddJoint',
  components: {Create, JobsCreate},
  props: ['line', 'joint', 'form_prop'],
  data() {
    return {
      isCreateJoint: false,
      createJoinInternal: true,
      save_joint: {},
      joints_table: {},
      joints: {
        start: null,
        end: null,
        dia: '',
        thi: '',
        inc: '',
        steel_grade: null,
      },
      form: {
        name: '',
        id: null,
        stamp: '',
        joints_labels: [],
        joints: [],
      },
    };
  },
  async mounted() {
    this.joints_table = await getInches(this.$store.state.project.id);
  },
  methods: {
    onJoinInput(joint) {
      const value = this.joints_table.find((d) => d.dia == joint.dia && d.width == joint.thi);

      if (value && value.inch && String(value.inch).length) {
        joint.inc = toFloat(value.inch);
      } else {
        joint.inc = '';
      }
    },
    open() {
      this.isCreateJoint = true;
      this.form = this.line.data || {
        name: '',
        id: null,
        stamp: '',
        joints_labels: [],
        joints: [],
      };
    },
    async deleteJoint(index) {
      const joints_labels = [...this.form.joints_labels];
      const joints = [...this.form.joints];
      _.remove(joints, {
        label: joints_labels[index].id,
      });
      joints_labels.splice(index, 1);
      this.form.joints = [...joints];
      this.form.joints_labels = joints_labels;
    },
    addJoints() {
      const joints_labels = this.form.joints_labels || [];
      const joints = this.form.joints || [];

      if (joints.find((j) => String(j.id).toUpperCase() === String(this.joints.start).toUpperCase())) {
        this.$notify({
          offset: 60,

          title: 'Упс... ',
          message: `Стык с номером ${this.joints.start} уже существует`,
          type: 'error',
        });
        return false;
      }
      this.save_joint = {
        id: String(this.joints.start).toUpperCase(),
        uid: uuidv4(),
        dia: toFloat(this.joints.dia),
        thi: toFloat(this.joints.thi),
        additional: this.createJoinInternal,
        inc: toFloat(this.joints.inc),
        steel_grade: this.joints.steel_grade,
        label: this.joints.start,
      };
      joints.push(this.save_joint);
      joints_labels.push(
        {
          id: String(this.joints.start).toUpperCase(),
          uid: uuidv4(),
          start: this.joints.start,
          end: this.joints.end,
          dia: toFloat(this.joints.dia),
          additional: this.createJoinInternal,
          thi: toFloat(this.joints.thi),
          inc: toFloat(this.joints.inc),
          steel_grade: this.joints.steel_grade,
        },
      );

      this.form.joints_labels = joints_labels;
      this.form.joints = joints;
      return true;
    },
    save() {
      if (this.addJoints()) {
        this.loading = true;
        myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('works_type')
          .doc(this.line.value)
          .update({
            ...this.form,
          }).then((add) => {
          this.$notify({
            offset: 60,

            title: 'Успешно!',
            message: 'Добавлено',
            type: 'success',
          });
          this.isCreateJoint = false;
          this.$emit('update', {data: this.form, new_joint: this.save_joint, joint: this.joint});

          this.joints = {
            start: null,
            end: null,
            dia: '',
            thi: '',
            inc: '',
            steel_grade: null,
          };
        }).catch((error) => {
          console.error(error);
          this.$notify({
            offset: 60,

            title: 'Ошибка',
            message: 'Перед тем как создать стык, выберите линию',
            type: 'error',
          });
        }).finally(() => {
          this.loading = false;
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.reports-add-joint {
  > > > .el-form-item {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .el-form-item__content {
      display: flex;
      justify-content: flex-start;
      width: 100%;
    }

    .el-form-item__label {
      padding: 0;
    }
  }

  &__buttons {
    margin-top: 28px;
    justify-content: space-between;
    width: 100%;
    flex: 1;
    display: flex;

    &:before {
    }

    &:after {
    }
  }

  .input-line-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    flex: 1;
  }

  .select-type {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
}

.joint {
  padding: 0px 20px;
  border-radius: 5px;
}

.in-line {
  display: flex;
}

.jobs-create__buttons {
  position: fixed;
  bottom: 0;
  max-width: 382px;
  width: calc(100% - 40px);
  background: #fff;
  border-top: 1px solid #ccc;
  padding: 10px;
}

.joint-li {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 20px;
}

.li-header {
  display: flex;
  justify-content: space-between;
  flex: 1;
  width: 100%;
}

.link-block {
  font-size: 14px;
  font-weight: bold;
  color: #409EFF;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
  position: relative;
  margin-bottom: -26px;
}
</style>




// WEBPACK FOOTER //
// src/views/Dashboard/Reports/components/AddJoint.vue